module.exports = __webpack_public_path__ + "img/145.3.9b5c6e0c.png";